import { config } from "../../../../../helpers/config_global"
import React, { Component, Fragment } from "react"
import { Redirect } from "react-router-dom"

import MKIDatatable from '../../../../../modules/mki-datatable/lib'
import { ConfirmAlert } from '../../../../../helpers/ui/alert'

import { cancelToken } from "../../../../../services/adapters/base"

import TableActiveBloc from '../Blocs/TableActiveBloc'
import apiResponse from '../../../../../services/apiResponse'

class TableActiveComponent extends Component {

    tableActiveBloc = new TableActiveBloc();

    source
    historyTable = 'historyTableActiveComponent'
    defaultOrder = 'menu_url'
    defaultSize = 10
    defaultSort = 'desc'
    configDatatable = {
        ...config('datatable'),
        sort: {
            column: this.defaultOrder,
            order: this.defaultSort
        },
        button: {
            excel: true
        }
    }

    constructor(props) {
        super(props)
        this.state = {
            detailId: 0,
            updateId: 0,
            defaultSize: 10,
            rows: [],
            totalRow: 0,
            loadingTable: true,
            filter: sessionStorage.getItem(this.historyTable) ?
                JSON.parse(sessionStorage.getItem(this.historyTable)) :
                {
                    filter_value: "",
                    page_number: 1,
                    page_size: this.defaultSize,
                    sort_order: {
                        column: this.defaultOrder,
                        order: this.defaultSort
                    }
                }
        }
    }

    loadData = async () => {
        /* history Datatable */
        sessionStorage.setItem(this.historyTable, JSON.stringify(this.state.filter))

        /* kirim ke server */
        let offset = (this.state.filter.page_number-1)*this.state.filter.page_size
        if(this.state.defaultSize!==this.state.filter.page_size) {
            this.setState({
                defaultSize: this.state.filter.page_size
            })
            offset = 0
            this.configDatatable.page_number = 1
        }
        const query = {
            search: this.state.filter.filter_value,
            limit: this.state.filter.page_size,
            offset: offset,
            order: this.state.filter.sort_order.column,
            sort: this.state.filter.sort_order.order
        }
        await this.tableActiveBloc.fetchData(query, this.source.token)
    }

    setTokenAPI = () => {
        if (typeof this.source != typeof undefined) {
            this.source.cancel();
        }
        this.source = cancelToken()
        this.loadData()
    }

    confirmResponse = (response) => {
        let forState = {}
        switch(response) {
            case 'cancel':
                forState = {
                    confirm: false
                }
                break;
            case 'confirm':
                forState = {
                    loading: true,
                    confirm: false
                }
                this.deleteData()
                break;
            case 'success':
                forState = {
                    success: false,
                    redirect: true
                }
                break;
             case 'failed':
                forState = {
                    failed: false
                }
                break;
            default:       
        }
        this.setState(forState)
    }
    
    deleteData = async () => {
        await this.delay(1000)
        this.setState({
            loading: false,
            success: true,
            loadingTable: true
        }, function () {
            this.setTokenAPI()
        });
    }
        delay(delayInms) {
            return new Promise(resolve => {
                setTimeout(() => {
                resolve(2);
                }, delayInms);
            });
        }

    componentDidMount() {
        this.setTokenAPI()

        this.tableActiveBloc.channel.subscribe((result) => {
            switch (result.status) {
                case apiResponse.INITIAL:
                    this.setState({
                        loadingTable: false
                    })
                    break
                case apiResponse.LOADING:
                    this.setState({
                        loadingTable: true
                    })
                    break
                case apiResponse.COMPLETED:
                    const response = result.data.response
                    this.setState({
                        totalRow: response.total,
                        rows: response.result,
                        loadingTable: false
                    })
                    break
                case apiResponse.ERROR:
                    
                    break
                default:
                    break
            }
        })
    }

    componentWillUnmount() {
        this.tableActiveBloc.channel.unsubscribe()
    }

    columns = [
        /* {
            key: "menu_id",
            text: "ID",
            className: "name",
            align: "left",
            width: 60
        }, */
        {
            key: "menu_parent_id",
            text: "ID Parent",
            className: "address",
            sortable: true,
            width: '20%'
        },
        {
            key: "menu_url",
            text: "URL",
            className: "postcode",
            sortable: true,
            width: '20%'
        },
        {
            key: "menu_name",
            text: "Nama Menu",
            className: "rating",
            sortable: true,
        },
        {
            key: "menu_icon",
            text: "Icon",
            className: "type_of_food",
            sortable: true,
            width: '20%',
            align: 'center',
            cell: record => { 
                return (
                    <center>
                        <i className={record.menu_icon}></i>
                    </center>
                )
            }
        },
        {
            key: "action",
            text: "Action",
            className: "action",
            width: 120,
            sortable: false,
            align: 'center',
            cell: record => { 
                return (
                    <Fragment>
                        <button
                            className="btn btn-success btn-sm"
                            onClick={() => {
                                this.setState({
                                    detailId: record.menu_id
                                })
                            }}
                            style={{
                                marginRight: '2px',
                                padding: '2px 5px'
                            }}>
                                <i className="uil-align-left"></i>
                        </button>
                        <button
                            className="btn btn-warning btn-sm"
                            onClick={() => {
                                this.setState({
                                    updateId: record.menu_id
                                })
                            }}
                            style={{
                                marginRight: '2px',
                                padding: '2px 5px'
                            }}>
                                <i className="uil-pen"></i>
                        </button>
                        <button 
                            className="btn btn-danger btn-sm" 
                            onClick={() => {
                                this.setState({
                                    confirm: true
                                })
                            }}
                            style={{
                                padding: '2px 5px'
                            }}>
                            <i className="uil-trash-alt"></i>
                        </button>
                    </Fragment>
                );
            }
        }
    ]

    render() {
        return (
            <>
                <MKIDatatable
                    className={this.configDatatable.tableClass}
                    config={this.configDatatable}
                    records={this.state.rows}
                    columns={this.columns}
                    dynamic={true}
                    minWidth={1000}
                    total_record={this.state.totalRow}
                    initial={this.state.filter}
                    onChange={(filter) => {
                        this.setState({
                            loadingTable: true,
                            filter: filter
                        }, function () {
                            this.setTokenAPI()
                        });
                    }}
                    loading={this.state.loadingTable}
                />
                <ConfirmAlert
                    confirmTitle="Konfirmasi!"
                    confirmInfo="Apakah anda yakin akan menghapus data ini?"

                    loadingTitle="Mengirim data..."
                    loadingInfo="Tunggu beberapa saat"

                    successTitle="Berhasil!"
                    successInfo="Data berhasil dihapus"

                    failedTitle="Gagal!"
                    failedInfo="Data gagal dihapus"

                    showConfirm={this.state.confirm}
                    showLoading={this.state.loading}
                    showSuccess={this.state.success}
                    showFailed={this.state.failed}

                    response={this.confirmResponse}
                />
                { this.state.detailId > 0 ?
                    <Redirect to={"/master/role.html?detail&id=" + this.state.detailId}/>
                : null }
                { this.state.updateId > 0 ?
                    <Redirect to={"/master/role.html?update&id=" + this.state.updateId}/>
                : null }
            </>
        )
    }

}

export default TableActiveComponent